<template>
  <div class="realname-page">
    <div class="clear">
      <h2 class="paging-title">实名认证</h2>
    </div>
    <div class="form">
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          上传身份证：
        </span>
        <div class="form-item-flex">
          <div class="card-wrapper">
            <el-upload
              class="btn-upload"
              :action="UploadImg"
              :on-success="uploadIDFront"
              :before-upload="beforeUpload"
              :show-file-list="false"
              accept="image/*"
            >
              <i class="card-file">身份证正面（人像）</i>
              <img
                v-if="form.IdCardFrontImg"
                :src="form.IdCardFrontImg"
                alt=""
                class="file-img"
              />
            </el-upload>
            <el-upload
              class="btn-upload"
              :action="UploadImg"
              :on-success="uploadIDBack"
              :before-upload="beforeUpload"
              :show-file-list="false"
              accept="image/*"
            >
              <i class="card-file">身份证反面</i>
              <img
                v-if="form.IdCardBackImg"
                :src="form.IdCardBackImg"
                alt=""
                class="file-img"
              />
            </el-upload>
          </div>
          <div class="tips">
            注：请上传本人身份证件正反面，确保图标清晰，四角完整。
          </div>
        </div>
      </div>
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          真实姓名：
        </span>
        <div class="form-item-flex">
          <input
            type="text"
            v-model.trim="form.TrueName"
            class="input"
            :readonly="isDisable"
          />
        </div>
      </div>
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          性别：
        </span>
        <div class="form-item-flex">
          <label class="radiobox" v-for="(item, index) in items" :key="index">
            <input
              type="radio"
              name="sex"
              v-model="form.Sex"
              :value="item.value"
              :readonly="isDisable"
            />
            <span class="icon-radio"></span>
            <span class="radio-text">{{ item.text }}</span>
          </label>
        </div>
      </div>
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          出生日期：
        </span>
        <div class="form-item-flex">
          <el-date-picker
            class="birthday"
            type="date"
            v-model="form.Birthday"
            placeholder="选择日期"
            :readonly="isDisable"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          身份证号：
        </span>
        <div class="form-item-flex">
          <input
            type="text"
            v-model.trim="form.IdCardNo"
            class="input"
            :readonly="isDisable"
          />
        </div>
      </div>
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          居住地址：
        </span>
        <div class="form-item-flex">
          <input
            type="text"
            v-model.trim="form.FamilyAddress"
            class="input"
            :readonly="isDisable"
          />
        </div>
      </div>
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          有效期：
        </span>
        <div class="form-item-flex">
          <el-date-picker
            class="range"
            type="date"
            v-model="form.IdCardStartDt"
            placeholder="选择日期"
            :picker-options="startOptions"
            :default-value="form.IdCardEndDt"
            :readonly="isDisable"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <span class="line">~</span>
          <div class="date-wrap">
            <el-date-picker
              class="range"
              type="date"
              ref="endDate"
              v-model="form.IdCardEndDt"
              placeholder="选择日期"
              :picker-options="endOptions"
              :readonly="isDisable"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <span
              class="long-term"
              @click="$refs.endDate.focus()"
              v-if="form.IdCardEndDt == '1900-01-01'"
              >长期</span
            >
          </div>
        </div>
      </div>
      <div class="form-item">
        <span class="label">
          <i class="required">*</i>
          上传近照：
        </span>
        <div class="form-item-flex">
          <el-upload
            class="btn-upload photo-upload"
            :action="UploadImg"
            :on-success="uploadPhoto"
            :before-upload="beforeUpload"
            :show-file-list="false"
            accept="image/*"
          >
            <i class="icon-file"></i>
            <img
              id="photo"
              v-if="form.PhotoUrl"
              :src="form.PhotoUrl"
              alt=""
              class="file-img"
            />
          </el-upload>
          <span class="tips">注：请上传清晰近照，图片不超过10MB。</span>
        </div>
      </div>
      <div class="form-item">
        <span class="label"></span>
        <div class="form-item-flex">
          <button class="btn-primary" @click="submit">提交认证</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  scanID,
  RealNamePersonAuth,
  AddErrorLog,
  UploadImg,
} from "@/scripts/api.js";
import { mapState } from "vuex";
export default {
  name: "personRealName",
  data() {
    return {
      UploadImg,
      form: {
        Birthday: "",
        TrueName: "",
        Sex: "",
        IdCardNo: "",
        FamilyAddress: "",
        IdCardFrontImg: "",
        IdCardBackImg: "",
        IdCardStartDt: "",
        IdCardEndDt: "",
        PhotoUrl: "",
      },
      items: [
        { value: 1, text: "男" },
        { value: 2, text: "女" },
      ],
      expiryDate: "",
      from: 0,
    };
  },
  created() {
    this.from = this.$route.query.from;
    console.log("route-from:" + this.$route.query.from);
    console.log("from:" + this.from);
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    // 开始时间禁用设置
    startOptions() {
      var obj = { disabledDate: null };
      if (this.form.IdCardEndDt) {
        obj.disabledDate = (time) => {
          return (
            time.getTime() > new Date(this.form.IdCardEndDt) ||
            time.getTime() < Date.now()
          );
        };
      }
      return obj;
    },
    // 结束时间禁用设置
    endOptions() {
      var that = this;
      var obj = { disabledDate: null };
      if (this.form.IdCardStartDt) {
        obj.disabledDate = (time) => {
          return time.getTime() < new Date(this.form.IdCardStartDt) - 86400000;
        };
      }
      obj.shortcuts = [
        {
          text: "长期",
          onClick(picker) {
            picker.$emit("pick", new Date(1900, 0, 1));
          },
        },
      ];
      return obj;
    },
    isDisable() {
      if (this.form.IdCardFrontImg == "" || this.form.IdCardBackImg == "") {
        return true;
      }
      return false;
    },
  },
  methods: {
    //上传之前
    beforeUpload(file) {
      let isLtSize = file.size / 1024 / 1024 < 10;
      if (!isLtSize) {
        this.$toast("上传文件大小不能超过 10MB!");
      }
      let fileType = file.name.substr(file.name.lastIndexOf("."));
      let fileArr = [".jpg", ".jpeg", ".gif", ".png"];
      let isFileAllowed = fileArr.indexOf(fileType.toLowerCase()) !== -1;
      if (!isFileAllowed) {
        this.$toast("上传文件格式不允许!");
      }
      return isLtSize && isFileAllowed;
    },
    // 上传身份证正面
    uploadIDFront(file, res) {
      if (file.Result == 1) {
        this.form.IdCardFrontImg = file.Data[0].imgUrl;
        scanID({
          AI_IDCARD_IMAGE: this.form.IdCardFrontImg,
          AI_IDCARD_IMAGE_TYPE: "1",
          AI_IDCARD_SIDE: "FRONT",
        }).then((r) => {
          if (r.PERSON_ID_SIDE_ENTITY.PERSON_ID_FRONT_SIDE_AMOUNT == 1) {
            this.form.TrueName = r.PERSON_ID_ENTITY.PERSON_NAME;
            this.form.Sex = r.PERSON_ID_ENTITY.PERSON_SEX == "男" ? 1 : 2;
            this.form.IdCardNo = r.PERSON_ID_ENTITY.PERSON_ID;
            this.form.FamilyAddress = r.PERSON_ID_ENTITY.PERSON_ADDRESS;
            let birthday = r.PERSON_ID_ENTITY.PERSON_BIRTH.replace("年", "-")
              .replace("月", "-")
              .replace("日", "");
            let arr = birthday.split("-");
            let month = arr[1] > 9 ? arr[1] : "0" + arr[1];
            let date = arr[2] > 9 ? arr[2] : "0" + arr[2];
            this.form.Birthday = arr[0] + "-" + month + "-" + date;
          }
        });
      } else {
        this.$toast(file.Message);
      }
    },
    // 上传身份证背面
    uploadIDBack(file, res) {
      if (file.Result == 1) {
        this.form.IdCardBackImg = file.Data[0].imgUrl;
        scanID({
          AI_IDCARD_IMAGE: this.form.IdCardBackImg,
          AI_IDCARD_IMAGE_TYPE: "1",
          AI_IDCARD_SIDE: "BACK",
        }).then((r) => {
          if (r.PERSON_ID_SIDE_ENTITY.PERSON_ID_BACK_SIDE_AMOUNT == 1) {
            let time = r.PERSON_ID_ENTITY.TIME_ZONE;
            let arr = time.split("-");
            this.form.IdCardStartDt = arr[0].replace(/\./g, "-");
            if (arr[1].indexOf(".") > 0) {
              this.form.IdCardEndDt = arr[1].replace(/\./g, "-");
            } else {
              this.form.IdCardEndDt = "1900-01-01"; //长期
            }
          }
        });
      } else {
        this.$toast(file.Message);
      }
    },
    // 上传照片
    uploadPhoto(file, res) {
      if (file.Result == 1) {
        this.form.PhotoUrl = file.Data[0].imgUrl;
      } else {
        this.$toast(file.Message);
      }
    },
    // 提交认证
    submit() {
      var from = this.from;

      if (this.form.IdCardFrontImg == "") {
        this.$toast("请上传身份证正面照片");
        return;
      }
      if (this.form.IdCardBackImg == "") {
        this.$toast("请上传身份证反面照片");
        return;
      }
      if (this.form.TrueName == "") {
        this.$toast("请输入真实姓名");
        return;
      }
      if (this.form.Sex == "") {
        this.$toast("请选择性别");
        return;
      }
      if (this.form.Birthday == "") {
        this.$toast("请选择出生日期");
        return;
      }
      if (this.form.IdCardNo == "") {
        this.$toast("请输入身份证号码");
        return;
      }
      if (this.form.FamilyAddress == "") {
        this.$toast("请输入居住地址");
        return;
      }
      if (this.form.IdCardStartDt == "" || this.form.IdCardEndDt == "") {
        this.$toast("请选择身份证有效期");
        return;
      }
      if (this.form.PhotoUrl == "") {
        this.$toast("请上传近期照片");
        return;
      }
      let params = {
        ...this.form,
        UserCode: this.userInfo.UserCode,
        platform: "pcweb",
      };

      RealNamePersonAuth(params).then((r) => {
        if (r.Result == 1) {
          this.$toast("认证成功！");
          this.$parent.initAsideMenu();
          this.$store.dispatch("loadAccountData");

          if (from == 1) {
            //从首页过来的，还转到首页
            this.$router.push("/home");
          } else {
            this.$router.push("/center/personalOverview");
          }
        } else {
          this.$toast(r.Message);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.realname-page {
  .paging-title {
    font-size: 18px;
    line-height: 24px;
    color: #f75959;
    margin-bottom: 20px;
    &:before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 20px;
      background-color: #f75959;
      vertical-align: middle;
      margin-top: -3px;
      margin-right: 16px;
    }
  }
  .form {
    background-color: #f9f9f9;
    padding-top: 34px;
    padding-bottom: 45px;
    .form-item {
      margin-bottom: 20px;
      &:after {
        content: "";
        display: block;
        clear: both;
      }
    }
    .label {
      float: left;
      min-width: 100px;
      height: 34px;
      margin-right: 20px;
      text-align: right;
      font-size: 14px;
      color: #999;
      line-height: 34px;
    }
    .form-item-flex {
      float: left;
      min-width: 400px;
    }
    .card-wrapper {
      overflow: hidden;
      width: 580px;
      margin-bottom: 10px;
      .btn-upload {
        float: left;
        width: 270px;
        height: 165px;
        margin-right: 15px;
        position: relative;
      }
    }
    .tips {
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
    .input {
      display: block;
      width: 100%;
      height: 34px;
      border: 1px solid #e5e5e5;
      padding: 5px 10px;
      font-size: 14px;
      color: #333;
      line-height: 22px;
      &:read-only {
        cursor: not-allowed;
        background-color: #f5f5f5;
      }
    }
    .file-img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .card-file {
      display: inline-block;
      position: relative;
      width: 270px;
      height: 165px;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      cursor: pointer;
      padding-top: 124px;
      font-size: 14px;
      color: #999;
      line-height: 24px;
      text-align: center;
    }

    .card-file:before,
    .card-file:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      border-radius: 2px;
      background-color: #e5e5e5;
    }

    .card-file:before {
      width: 60px;
      height: 8px;
      margin-left: -30px;
      margin-top: -4px;
    }

    .card-file:after {
      width: 8px;
      height: 60px;
      margin-top: -30px;
      margin-left: -4px;
    }
    .icon-file {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      cursor: pointer;
    }

    .icon-file:before,
    .icon-file:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      background-color: #e5e5e5;
    }

    .icon-file:before {
      width: 40px;
      height: 2px;
      margin-left: -20px;
      margin-top: -1px;
    }

    .icon-file:after {
      width: 2px;
      height: 40px;
      margin-top: -20px;
      margin-left: -1px;
    }
    .radiobox {
      position: relative;
      cursor: pointer;
      line-height: 24px;
      margin-right: 30px;
      input {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        z-index: 2;
      }
    }
    .icon-radio {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid #e5e5e5;
      background-color: #fff;
      margin-right: 10px;
      vertical-align: middle;
    }
    :checked + .icon-radio {
      border-color: #f75959;
      background-color: #f75959;
      padding: 2px;
      background-clip: content-box;
    }
    .radio-text {
      vertical-align: middle;
      white-space: nowrap;
      font-size: 14px;
      color: #999;
    }
    .photo-upload {
      width: 80px;
      height: 80px;
      position: relative;
    }
    .btn-primary {
      display: block;
      width: 100px;
      height: 30px;
      margin-top: 50px;
      text-align: center;
      line-height: 30px;
      background-color: #f75959;
      border-radius: 2px;
      color: #fff;
      font-size: 14px;
    }
    .range {
      width: 190px;
    }
    .line {
      display: inline-block;
      color: #999;
      vertical-align: middle;
      width: 20px;
      text-align: center;
    }
    .birthday {
      width: 100%;
    }
    .el-date-editor {
      border-radius: 0;
      * {
        line-height: 34px;
      }
    }
    .el-input__inner {
      border-radius: 0;
      height: 34px;
      line-height: 34px;
      border-color: #e5e5e5;
      &:read-only {
        cursor: not-allowed;
        background-color: #f5f5f5;
      }
    }
    .date-wrap {
      display: inline-block;
      position: relative;
    }
    .long-term {
      position: absolute;
      left: 30px;
      top: 5px;
      width: 100px;
      line-height: 24px;
      color: #606266;
      font-size: 14px;
      background-color: #fff;
    }
  }
}
</style>